import { getRequest, postRequest } from "NetworkCall";
import { INSTANCE_URL } from "Constants";
export const ATTENDEESMESSAGING_TOTAL_SENTMSG =
  "ATTENDEESMESSAGING_TOTAL_SENTMSG";

// Attendee Sent Message (Attendees who sent at least one message)
const attendeesmessagingsentmsgcount = (session, callback) => {
  var url = `${INSTANCE_URL}/api/v2/analytics?type=atndssentmsgcnt`;
  return (dispatch) => {
    postRequest(
      url,
      {
        type: "atndssentmsgcnt",
        eventid: session.eventid,
      },
      session,
      dispatch,
      (response) => {
        var data = response;

        //Prepare data for ..
        dispatch({
          type: ATTENDEESMESSAGING_TOTAL_SENTMSG,
          payload: { response: data, count: data.resource.length },
        });
        callback({
          error: 0,
          data: "Analytics, How many messages are sent in the App !",
        });
      },
      (error) => {
        callback({ error: 1, data: null });
      }
    );
  };
};

export { attendeesmessagingsentmsgcount };
